module.exports = __webpack_public_path__ + "static/media/cq_percentuale.f5cdcee5.svg";